
 



 
 import {fs} from "Config/FsConfig";
 
    import PublicNewsSearchParameter from 'Modules/Aqs/Scripts/AppServiceContract/PublicNewsSearchParameter';

    import NewsData from 'Modules/Aqs/Scripts/AppServiceContract/NewsData';

    import PublicNewsCriteria from 'Modules/Aqs/Scripts/AppServiceContract/PublicNewsCriteria';

    import NewsTypeData from 'Modules/Aqs/Scripts/AppServiceContract/NewsTypeData';


    //module PublicNewsAppService {
    class PublicNewsAppService {

    ControllerUrl : string
    Options : JQueryAjaxSettings

    constructor(serverBaseUrl : string = null, controllerPath : string = null, ajaxOptions : JQueryAjaxSettings = null){
        this.ControllerUrl = ((serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : serverBaseUrl) + ((controllerPath == null) ?  "modules/Aqs.AppService/PublicNewsAppService" : controllerPath);
        this.Options = ajaxOptions;
    }

    public Init(options : any = { serverBaseUrl :  null, controllerPath : null, ajaxOptions : null }){
        this.ControllerUrl = ((options.serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : options.serverBaseUrl) + ((options.controllerPath == null) ?  "modules/Aqs.AppService/PublicNewsAppService" : options.controllerPath);
        this.Options = options.ajaxOptions;

        return this;
    }

    
    // post: api/${controller}/
    //public static RouteFind = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicNewsAppService/Find`;
    public RouteFind() : string {
        return this.ControllerUrl + "/"+"Find";
    }
    public Find(searchParameter: PublicNewsSearchParameter): JQuery.jqXHR<NewsData[]> {
        return $.ajax({
                url: this.RouteFind(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(searchParameter),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteCount = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicNewsAppService/Count`;
    public RouteCount() : string {
        return this.ControllerUrl + "/"+"Count";
    }
    public Count(criteria: PublicNewsCriteria): JQuery.jqXHR<number> {
        return $.ajax({
                url: this.RouteCount(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(criteria),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/?newsId=${encodeURIComponent(newsId)}
    //public static RouteLoadNews = (newsId: string) => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicNewsAppService/LoadNews`;
    public RouteLoadNews(newsId: string) : string {
        return this.ControllerUrl + "/"+"LoadNews";
    }
    public LoadNews(newsId: string): JQuery.jqXHR<NewsData> {
        return $.ajax({
                url: this.RouteLoadNews(newsId),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(newsId),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindNewsType = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicNewsAppService/FindNewsType`;
    public RouteFindNewsType() : string {
        return this.ControllerUrl + "/"+"FindNewsType";
    }
    public FindNewsType(): JQuery.jqXHR<NewsTypeData[]> {
        return $.ajax({
                url: this.RouteFindNewsType(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindLastNewType = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicNewsAppService/FindLastNewType`;
    public RouteFindLastNewType() : string {
        return this.ControllerUrl + "/"+"FindLastNewType";
    }
    public FindLastNewType(): JQuery.jqXHR<NewsData[]> {
        return $.ajax({
                url: this.RouteFindLastNewType(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
}

export default PublicNewsAppService;



